<template>
<div class="animated fadeIn">
  <div class="mt-4">
    <div class="">
      <div class="row mb-2">
          <div class="col-md-4 m-auto">
            <b-form inline>
                <label class="mr-sm-2">{{$t('STATUS')}}</label>
                <b-form-select :options="status" v-model="userStatus"></b-form-select>
            </b-form>
          </div>
          <div class="col-md-8 m-auto">
            <button type="button" class="btn btn-add float-right" @click="showModal()">
              <!-- icon icon="plus"></icon --> {{$t('ADDUSER')}}
            </button>
          </div>
      </div>
      <div class="clear20">&nbsp;</div>
      <div class="row mb-2">
        <div class="col-sm-12">
          <table class="table table-foursight table-striped table-hover table-sm">
            <thead>
              <tr>
                <th>{{$t('NAME')}}</th>
                <th>{{$t('ACCESSLEVEL')}}</th>
                <th>{{$t('EMAILADDRESS')}}</th>
                <th>{{$t('STATUS')}}</th>
                <th>{{$t('PROBATIONSTATUS')}}</th>
                <th>{{$t('THISYEARSALES')}}</th>
                <th>{{$t('TRAININGPROGRESS')}}</th>
                <th>{{$t('ACTION')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in data.root">
                <tr aria-rowindex="1" class=" table-ellipsis">
                  <td>{{item.name}}</td>
                  <td>{{item.groupName}}</td>
                  <td>{{item.userEmail}}</td>
                  <td>{{$t(item.status.toUpperCase())}}</td>
                  <td>${{item.thisprobationPeriod}}</td>
                  <td>${{item.thisYearSales}}</td>
                  <td>
                    <b-button type="reset" size="sm" variant="primary" @click="showExamPage(item.userId)">
                      {{$t('TRAININGPROGRESS')}}
                    </b-button>
                  </td>
                  <td>
                    <b-button type="reset" size="sm" variant="primary" @click="showQuestionPage(item.userId)">
                      {{$t('QUESTIONFORM')}}
                    </b-button>
                  </td>
                  <td>
                    <button type="button" class="btn btn-primary btn-sm mr-2" @click="showScheduleModal(item)">{{$t('SCHEDULEUPCOMING')}}</button>
                    <button type="button" class="btn btn-secondary btn-sm mr-2" @click="showModal(item)">{{$t('EDIT')}}</button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <b-modal ref="formmodal" :title="$t('USERSFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop>
    <div class="d-block">
      <userform v-bind:formData="formData" v-bind:formError="formError" v-bind:status="status"></userform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="saveRow(formData)">{{$t('SAVE')}}</b-btn>
    </div>
  </b-modal>
  <b-modal ref="formsummarymodal" :title="$t('SCHEDULESUMMARYFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
    <div class="d-block">
      <userschedulesummaryform v-bind:scheduleSummary="scheduleSummary"></userschedulesummaryform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans" @click="hideSummaryModal">{{$t('CANCEL')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'

import StoreApi from '@/api/salesportal/Store'
import Api from '@/api/admin/Users'
import UsersForm from '../../../../admin/UsersForm.vue'

import SchedualApi from '@/api/salesportal/Schedual'
import UserScheduleSummaryForm from './UserScheduleSummaryForm'

export default
{
  name: 'EmployeesWin',
  props: ['storeId', 'tabIndex'],
  components:
  {
    userform: UsersForm,
    userschedulesummaryform: UserScheduleSummaryForm
  },
  data: function()
  {
    var me = this;
    return {
      data:
      {},
      scheduleSummary:
      {},
      formError:
      {},
      formData:
      {
        username: '',
        password: '',
        userEmail: '',
        groupId: 2,
        status: 'active',
        oldSalesPortal: '',
        storeId: null,
        address: '',
        city: '',
        postalCode: '',
        country: '',
        phone: ''
      },
      userStatus: 'active',
      status: [
      {
        value: 'active',
        text: me.$i18n.t('ACTIVE')
      },
      {
        value: 'inactive',
        text: me.$i18n.t('INACTIVE')
      }]
    }
  },
  created()
  {
    var me = this;
    //me.getData();
  },
  methods:
  {
    showExamPage(id)
    {
      var me = this;
      me.$router.push(
      {
        path: `/salesportal/store/storedetails/${me.storeId}/examprogres/${id}`
      });
    },
    showQuestionPage(id)
    {
      var me = this;
      me.$router.push(
      {
        path: `/salesportal/store/storedetails/${me.storeId}/questionprogres/${id}`
      });
    },
    async getData()
    {
      var me = this;
      try
      {
        var data = await StoreApi.selectUsers(
        {
          storeId: me.storeId,
          userStatus: me.userStatus
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.data = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showModal(item)
    {
      var me = this;
      if (typeof item != 'undefined') me.formData = item;
      else
      {
        me.$set(me.formData, 'storeId', me.storeId);
        me.$set(me.formData, 'groupId', 4);
      }

      this.$refs.formmodal.show()
    },
    saveRow: function(item)
    {
      var me = this;

      if (typeof item.userId != 'undefined')
      {
        item.id = item.userId;
        delete(item.userId);
      }

      Api.save(item, function(val)
      {
        if (val.error)
        {
          me.$notify.notice(val);
          me.formError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formError = {};
          me.getData();
          me.hideModal();
        }
      })
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();

      me.formData = {
        username: '',
        password: '',
        userEmail: '',
        userGroup: 2,
        status: 'active',
        oldSalesPortal: '',
        storeId: null,
        address: '',
        city: '',
        postalCode: '',
        country: '',
        phone: ''
      }
    },
    async getScheduleSummary(id)
    {
      var me = this;
      try
      {
        var data = await SchedualApi.getUserScheduleSummary(
        {
          userId: id
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.scheduleSummary = data.root;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showScheduleModal(item)
    {
      var me = this;
      me.getScheduleSummary(item.userId);
      this.$refs.formsummarymodal.show()
    },
    hideSummaryModal()
    {
      var me = this;
      this.$refs.formsummarymodal.hide();
    }
  },
  watch:
  {
        async tabIndex(val)
        {
              var me = this;
              try
              {
                if (val == 1)
                {
                  await me.getData();
                }
              }
              catch (error)
              {
                me.$notify.notice(e);
              }
        },
        userStatus(val)
        {
            var me = this;
            me.getData();
        }
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
